import ValoresRepository from "@/services/ValoresRepository";

export default {
  namespaced: true,
  state: {
    listaVariedad: [],
    listaVariedadTemporada: [],
    listaVariedadTemporadaAgricultor: [],
  },
  getters: {
    getVariedad: (state) => (idVariedad) => {
      return state.listaVariedad.find(
        (variedad) => variedad.idVariedad === idVariedad
      );
    },

    listaCultivoTemporada(state) {
      return state.listaVariedadTemporada.reduce((lista, variedad) => {
        let cultivo = lista.find(
          (item) => item.idCultivo === variedad.cultivo.idCultivo
        );
        if (!cultivo) {
          lista.push({
            idCultivo: variedad.cultivo.idCultivo,
            nombre: variedad.cultivo.nombre,
          });
        }
        return lista;
      }, []);
    },

    getCultivoTemporada: (state, getters) => (idCultivo) => {
      return getters.listaCultivoTemporada.find(
        (cultivo) => cultivo.idCultivo === idCultivo
      );
    },

    listaCultivoTemporadaAgricultor(state) {
      return state.listaVariedadTemporadaAgricultor.reduce(
        (lista, variedad) => {
          let cultivo = lista.find(
            (item) => item.idCultivo === variedad.cultivo.idCultivo
          );
          if (!cultivo) {
            lista.push({
              idCultivo: variedad.cultivo.idCultivo,
              nombre: variedad.cultivo.nombre,
            });
          }
          return lista;
        },
        []
      );
    },

    getCultivoTemporadaAgricultor: (state, getters) => (idCultivo) => {
      return getters.listaCultivoTemporadaAgricultor.find(
        (cultivo) => cultivo.idCultivo === idCultivo
      );
    },
  },
  mutations: {
    setListaVariedad(state, listaVariedad) {
      state.listaVariedad = listaVariedad.map((variedad) => {
        let nombreCultivo = variedad.cultivo.nombre;
        let nombreVariedad = variedad.nombre;
        variedad.cultivoVariedad =
          nombreCultivo === nombreVariedad
            ? nombreCultivo
            : nombreCultivo + " " + nombreVariedad;
        return variedad;
      });
    },

    setListaVariedadTemporada(state, listaVariedadTemporada) {
      state.listaVariedadTemporada = listaVariedadTemporada.map((variedad) => {
        let nombreCultivo = variedad.cultivo.nombre;
        let nombreVariedad = variedad.nombre;
        variedad.cultivoVariedad =
          nombreCultivo === nombreVariedad
            ? nombreCultivo
            : nombreCultivo + " " + nombreVariedad;
        return variedad;
      });
    },

    setListaVariedadTemporadaAgricultor(
      state,
      listaVariedadTemporadaAgricultor
    ) {
      state.listaVariedadTemporadaAgricultor =
        listaVariedadTemporadaAgricultor.map((variedad) => {
          let nombreCultivo = variedad.cultivo.nombre;
          let nombreVariedad = variedad.nombre;
          variedad.cultivoVariedad =
            nombreCultivo === nombreVariedad
              ? nombreCultivo
              : nombreCultivo + " " + nombreVariedad;
          return variedad;
        });
    },

    clearListaVariedadTemporadaAgricultor(state) {
      state.listaVariedadTemporadaAgricultor = [];
    },

    clearListaVariedades(state) {
      state.listaVariedad = [];
    },
  },
  actions: {
    async fetchListaVariedad({ state, commit }) {
      if (state.listaVariedad && state.listaVariedad.length > 0) {
        return;
      }

      let listaVariedad = await ValoresRepository.listaVariedad();
      commit("setListaVariedad", listaVariedad);
    },

    async clearListaVariedades({ commit }) {
      commit("clearListaVariedades");
    },

    async fetchListaVariedadTemporada({ commit }, [idTemporada]) {
      let listaVariedadTemporada =
        (await ValoresRepository.listaVariedadTemporada(idTemporada)) || [];
      commit("setListaVariedadTemporada", listaVariedadTemporada);
    },

    async fetchListaVariedadTemporadaAgricultor({ state, commit, rootState }) {
      if (
        state.listaVariedadTemporadaAgricultor &&
        state.listaVariedadTemporadaAgricultor.length > 0
      ) {
        return;
      }

      let idEstablecimiento =
        rootState.establecimientos.establecimiento.idEstablecimiento;
      let idGrupoExplotacion =
        rootState.establecimientos.currentGrupoExplotacion.idGrupoExplotacion;
      let idTemporada = rootState.temporada.temporada.idTemporada;

      if (idEstablecimiento !== 0 && idGrupoExplotacion !== 0) {
        let listaVariedadTemporadaAgricultor =
          (await ValoresRepository.listaVariedadTemporadaAgricultor(
            idEstablecimiento,
            idGrupoExplotacion,
            idTemporada
          )) || [];
        commit(
          "setListaVariedadTemporadaAgricultor",
          listaVariedadTemporadaAgricultor
        );
      }
    },

    async clearListaVariedadTemporadaAgricultor({ commit }) {
      commit("clearListaVariedadTemporadaAgricultor");
    },
  },
};
